<template>
	<div class="row">
		<div class="col-xs-12 text-center">
			<a href="javascript:void(0)" class="button button-3" @click="$router.go(-2)">{{ $t('Link.GoBack') }}</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'BackInHistory',
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/BackInHistory.vue